import React from "react";
import { Box, Typography } from "@mui/material";
import AccountClockIcon from "@iconify/icons-mdi/account-clock";
import AccountPlusIcon from "@iconify/icons-mdi/account-plus";
import CityIcon from "@iconify/icons-mdi/city";
import CreditCardIcon from "@iconify/icons-mdi/credit-card-marker-outline";
import FileIcon from "@iconify/icons-mdi/file-account";
import HomeAccountIcon from "@iconify/icons-mdi/home-account";
import SiteMapIcon from "@iconify/icons-mdi/sitemap";
import { MyHrContractCardItem } from "my-hr/components";

interface MyHrContractProps {
  contract: {
    jobClass?: { name?: string };
    code?: string;
    company?: { name?: string };
    workingPlace?: { name?: string };
    orgUnit?: { name?: string };
    payOffice?: { name?: string };
    _id?: string;
    validFrom?: string | Date;
    employmentType?: { name?: string };
    // add other fields as needed
  };
  isMobile: boolean;
}

export const MyHrContract: React.FC<MyHrContractProps> = ({
  contract,
  isMobile,
}) => {
  let jobClassName = contract?.jobClass?.name
    ? contract.jobClass.name.charAt(0).toUpperCase() +
      contract.jobClass.name.slice(1)
    : "";

  return (
    <Box padding="0px 32px">
      <Box style={{ borderTop: "1px solid #C6CACC" }}>
        <Typography
          variant="h5"
          style={{ marginTop: "16px", marginBottom: "4px" }}
        >
          {jobClassName} - {contract?.code}
        </Typography>
        {isMobile && <Box height="16px" />}
        <Box display="flex" flexDirection={isMobile ? "column" : "row"}>
          <Box flexGrow={1}>
            {" "}
            <MyHrContractCardItem
              icon={CityIcon}
              label={contract?.company?.name ?? ""}
            />
            <MyHrContractCardItem
              icon={HomeAccountIcon}
              label={contract?.workingPlace?.name ?? ""}
            />
            <MyHrContractCardItem
              icon={SiteMapIcon}
              label={contract?.orgUnit?.name ?? ""}
            />
            <MyHrContractCardItem
              icon={CreditCardIcon}
              label={contract?.payOffice?.name ?? ""}
            />
          </Box>
          <Box flexGrow={1}>
            {" "}
            <MyHrContractCardItem icon={FileIcon} label={contract?._id ?? ""} />
            <MyHrContractCardItem
              icon={AccountPlusIcon}
              label={
                contract?.validFrom
                  ? new Date(contract.validFrom).toLocaleDateString()
                  : ""
              }
            />
            <MyHrContractCardItem
              icon={AccountClockIcon}
              label={contract?.employmentType?.name ?? ""}
            />
          </Box>
        </Box>
        {isMobile && <Box height="16px" />}
      </Box>
    </Box>
  );
};

export default MyHrContract;
